import { render, staticRenderFns } from "./PresentacionUpdateView.vue?vue&type=template&id=c0290fc6&"
import script from "./PresentacionUpdateView.vue?vue&type=script&lang=js&"
export * from "./PresentacionUpdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports